const stylesCard = {
    card: {
        background: "white",
        border: "ActiveBorder",
        borderRadius: "0.7rem",
        padding: "1rem 1rem",
        fontFamily: "Raleway,sans-serif"
    },
    title: {
        color: "black",
        fontWeight: "bold",
        fontFamily: "Raleway,sans-serif"
    },
    subtitle: {
        color: "darkgray",
        fontFamily: "Raleway,sans-serif"
    },
    count: {
        color: "black",
        textAlign: "center",
        fontFamily: "Raleway,sans-serif"
    }
};

export default stylesCard;